export default "__VITE_ASSET__BmcdMJTp__"